import React from 'react'
import styles from './OauthIntegration.module.scss'
import OauthCard from './oauth-card/OauthCard'
import { Translate } from 'react-localize-redux'
import { RouterConfig } from '../../../core/utils/constants'
import { Link } from 'react-router-dom'
import { Button, ButtonType } from '@digicert/dcone-common-ui'

const OauthIntegration = (props) => {
  return (
    <div className={styles.oAuthIntegration}>
      <div>
        {props.removeAddIntegration && <>
          <p><Translate id={'oauthIntegration.integrationDescription'} /></p>
          <Link className={styles.link} to={RouterConfig.platformSettings.addOauth()}>
            <Button
              buttonType={ButtonType.SECONDARY} >
              <Translate id='oauthIntegration.integrationButtonLabel' />
            </Button>
          </Link>
        </>}
        <OauthCard canManagePermission={true} />
      </div>
    </div>
  )
}

export default OauthIntegration
